'use client';

import './_error-template.scss';
import { useEffect } from 'react';
import Button from '@commons/Button';

export default function ErrorTemplate({ error = null, reset = null }) {
  useEffect(() => {
    if (error) {
      console.error(error);
    }
  }, [error]);

  const heading_text = 'Noe gikk galt';
  const body_text = 'En uventet feil oppstod. Du kan prøve å laste inn siden på nytt.';

  return (
    <article className="Error">
      <div className="Error__content">
        <h1 className="Error__heading">{heading_text}</h1>
        <p className="Error__body">{body_text}</p>
        <div className="Error__actions">
          {reset ? <Button onClick={() => reset()}>Last inn på nytt</Button> : <Button href="/">Til forsiden</Button>}
        </div>
      </div>
    </article>
  );
}
